export function notifyAppliedMediaRequirementUpdate(recommendation) {
  const applied = recommendation?.data?.media_requirement_update_applied
    || recommendation?.media_requirement_update_applied;
  if (!applied || typeof window === 'undefined') return false;
  window.dispatchEvent(new CustomEvent('regimen:plan:updated', {
    detail: {
      kind: 'media_requirements',
      activityIds: Array.isArray(applied.media_activity_ids) ? applied.media_activity_ids : [],
    },
  }));
  return true;
}
